module.exports = __webpack_public_path__ + "static/cute-girl-writing-on-notebook-smiling-at-camera-b9d86221aff65228d939468551a8fa3f.jpg";